module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'dropdown-wrapper ' + (_vm.isOpen ? 'active' : '') + ' ' + (_vm.validated ? 'validated' : '') + ' type--' + _vm.type + ' ' + (_vm.error ? 'error' : '')
  }, [_c('label', {
    on: {
      "click": _vm.toggle
    }
  }, [(_vm.prefixicon) ? _c('span', {
    staticClass: "prefix"
  }, [(!_vm.validated) ? _c('icon', {
    attrs: {
      "name": _vm.prefixicon,
      "scale": 2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.validated) ? _c('icon', {
    attrs: {
      "name": _vm.prefixiconValidated,
      "scale": 2
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.combo && _vm.isOpen) ? _c('div', {
    staticClass: "value-editor"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.stopper($event)
      },
      "keyup": function($event) {
        return _vm.setValueFromTyping($event, {
          value: _vm.search
        })
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.combo && !_vm.isOpen) ? _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLabel)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.combo && !_vm.valuebinder) ? _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLabel)
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.combo && _vm.valuebinder) ? _c('div', {
    staticClass: "value",
    domProps: {
      "innerHTML": _vm._s(_vm.selectedLabel + ' ' + _vm.valueSuffix)
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "suffix",
    on: {
      "click": _vm.clickSuffix
    }
  }, [(_vm.type === 'large' && _vm.allowEmpty) ? _c('icon', {
    attrs: {
      "name": _vm.validated ? 'circle-green-minus' : 'chevron-down',
      "scale": _vm.validated ? 1.6 : 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'large' && !_vm.allowEmpty) ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'clean') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'language') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'country') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'cleanlarge') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'month') ? _c('icon', {
    attrs: {
      "name": 'chevron-down',
      "scale": 1.2
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'mini') ? _c('icon', {
    attrs: {
      "name": "sort-blue",
      "scale": 1
    }
  }) : _vm._e()], 1)]), _vm._v(" "), (_vm.isOpen) ? _c('div', {
    ref: "options",
    staticClass: "options",
    style: ('max-height:' + this.optionHeight + 'px;')
  }, [_vm._l((_vm.filteredOptions), function(option) {
    return _c('div', {
      class: {
        selected: (option.value === _vm.valuebinderComputed), option: true, 'option-row': !option.separator, separator: option.separator
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setValue(option)
        }
      }
    }, [(_vm.type === 'clean') ? _c('Checkbox', {
      attrs: {
        "label-position": "after",
        "label": "",
        "value": option.value,
        "valuebinder": _vm.tempValue,
        "size": 16
      },
      on: {
        "update:valuebinder": function($event) {
          _vm.tempValue = $event
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'language') ? _c('div', {
      staticClass: "flag",
      style: ('background-image: url(https://cdnjs.cloudflare.com/ajax/libs/flag-icon-css/3.2.0/flags/1x1/' + option.flag + '.svg)')
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'country') ? _c('div', {
      staticClass: "flag",
      style: ('background-image: url(' + option.flag + ')')
    }) : _vm._e(), _vm._v(" "), _c('b', {
      staticStyle: {
        "margin-left": "7px"
      },
      domProps: {
        "innerHTML": _vm._s(option.title)
      }
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.subtitle))]), _vm._v(" "), (option.price1) ? _c('span', {
      class: {
        price: true,
          marked: option.marked
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(option.price1)))]) : _vm._e(), _vm._v(" "), (_vm.type === 'language') ? _c('Checkbox', {
      attrs: {
        "label-position": "after",
        "label": "",
        "value": option.value,
        "valuebinder": _vm.tempValue,
        "size": 16
      },
      on: {
        "update:valuebinder": function($event) {
          _vm.tempValue = $event
        }
      }
    }) : _vm._e(), _vm._v(" "), (_vm.type === 'country') ? _c('Checkbox', {
      attrs: {
        "label-position": "after",
        "label": "",
        "value": option.value,
        "valuebinder": _vm.tempValue,
        "size": 16
      },
      on: {
        "update:valuebinder": function($event) {
          _vm.tempValue = $event
        }
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _vm._t("default")], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22344c9b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/components/Dropdown.vue
// module id = 920
// module chunks = 0